var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Page",
    [
      _c(
        "template",
        { slot: "header-left-dropdown" },
        [
          _c("PageTabButtons", {
            staticClass: "z-index-xs",
            attrs: {
              selectedList: _vm.PageLinks,
              translationGroup: "TabItems",
            },
          }),
        ],
        1
      ),
      _c(
        "template",
        { slot: "header-right-content" },
        [
          _c(
            "Button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.IsEmptyFieldsList,
                  expression: "!IsEmptyFieldsList",
                },
              ],
              attrs: {
                primary: "",
                size: "medium",
                iconName: "icon-global-add",
              },
              on: { click: _vm.addNewOptionalFields },
            },
            [
              _c("span", [
                _vm._v(_vm._s(_vm.$t("OptionalFields.newOptionalField"))),
              ]),
            ]
          ),
        ],
        1
      ),
      _c(
        "template",
        { slot: "content-center" },
        [
          !_vm.isFetchingList && _vm.IsEmptyFieldsList
            ? _c("EmptyState", {
                attrs: {
                  title: _vm.$t("OptionalFields.emptyState_Title"),
                  description: _vm.$t("OptionalFields.emptyState_Description"),
                  buttonText: _vm.$t("OptionalFields.newOptionalField"),
                },
                on: { emptyAddButton: _vm.addNewOptionalFields },
              })
            : _vm._e(),
          _vm.isFetchingList ? _c("TableLoading") : _vm._e(),
          _c(
            "div",
            [
              !_vm.isFetchingList && !_vm.IsEmptyFieldsList
                ? _c("TableView", {
                    attrs: {
                      data: _vm.OptionalFields,
                      fields: _vm.fields,
                      actions: ["edit", "delete"],
                      page: _vm.Page,
                    },
                    on: {
                      delegateOnItemEdit: _vm.onItemEdit,
                      delegateOnItemDelete: _vm.onItemDelete,
                      delegateOnChangePage: _vm.changePage,
                      delegateOnChangePageSize: _vm.changePageSize,
                    },
                  })
                : _vm._e(),
              _c("portal", {
                attrs: { to: "columnType" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (row) {
                      return _c("div", {}, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.customInput(row.columnType))),
                        ]),
                      ])
                    },
                  },
                ]),
              }),
              _c("portal", {
                attrs: { to: "tableType" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (row) {
                      return _c("div", {}, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.getModuleName(row.tableType))),
                        ]),
                      ])
                    },
                  },
                ]),
              }),
              _c("portal", {
                attrs: { to: "isRequired" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (row) {
                      return _c("div", {}, [
                        row.columnType === 1 || row.columnType === 3
                          ? _c(
                              "span",
                              {
                                class: row.isRequired
                                  ? "c-success"
                                  : "c-warning",
                              },
                              [
                                _c("Icon", {
                                  attrs: {
                                    name: _vm.validateIcon(row.isRequired),
                                  },
                                }),
                              ],
                              1
                            )
                          : _c("span", [_vm._v("-")]),
                      ])
                    },
                  },
                ]),
              }),
              _c("portal", {
                attrs: { to: "isUnique" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (row) {
                      return _c("div", {}, [
                        row.columnType === 1
                          ? _c(
                              "span",
                              {
                                class: row.isUnique ? "c-success" : "c-warning",
                              },
                              [
                                _c("Icon", {
                                  attrs: {
                                    name: _vm.validateIcon(row.isUnique),
                                  },
                                }),
                              ],
                              1
                            )
                          : _c("span", [_vm._v("-")]),
                      ])
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("router-view"),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }